import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FeatureToggleSettings } from '../featuresToggleSettings.model';
import { produce } from 'immer';
import { Consts } from '@shared/consts';

export interface FeatureToggleState {
	featureToggles: FeatureToggleSettings[];
	lastUpdate: Date;
}

export function createInitialState(): FeatureToggleState {
	return {
		featureToggles: [],
		lastUpdate: null as Date
	};
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: Consts.FeatureToggleStoreName, producerFn: produce  })
export class FeatureToggleStore extends Store<FeatureToggleState> {
	constructor() {
		super(createInitialState());
	}
}